import React from 'react';
import { styled } from 'linaria/react';
import t from '@jetshop/intl';
import { theme } from '../../Theme';
const PaginationContainer = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 0;
`;

const ProductCount = styled('div')`
  font-size: 14px;
  color: #333;
  margin-bottom: 16px;
  text-align: center;
`;

const ShowMoreButton = styled('button')`
  background: #911827;
  color: #fff;
  border: none;
  border-radius: 25px;
  padding: 10px 24px;
  cursor: pointer;
  font-size: 14px;
  margin-bottom: 16px;
  width: auto;
  text-transform: uppercase;
  font-family: ${theme.fonts.primary};
  font-weight: 300;
  letter-spacing: 0.5px;

  &:hover {
    opacity: 0.9;
  }

  &[disabled] {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const PaginationWrapper = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-top: 8px;
`;

const PageNumber = styled('button')`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: none;
  background: ${(props) => (props.isActive ? '#911827' : '#f0f0f0')};
  color: ${(props) => (props.isActive ? '#fff' : '#333')};
  cursor: pointer;
  font-size: 13px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: ${(props) => (props.isActive ? '#911827' : '#f0f0f0')};
  }
`;

const Ellipsis = styled('span')`
  color: #333;
  padding: 0 4px;
`;

const GraphWrapper = styled('div')`
  width: calc(100% / 3);
  margin: 20px auto;
`;

const GraphBar = styled('div')`
  height: 3px;
  background: #33333333;
  position: relative;
  width: 100%;
  &::before {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    background-color: #911830;
    left: 0;
    height: 100%;
    width: ${(props) => Math.round(props.fill)}%;
  }
`;

const StatusBar = ({ currentPage, totalPages }) => {
  const percentage = (currentPage / totalPages) * 100;
  return (
    <GraphWrapper>
      <GraphBar fill={percentage} />
    </GraphWrapper>
  );
};

export function Pagination({
  totalItems,
  currentPage,
  totalPages,
  goToPage,
  nextPage,
  isLastPage,
  hasPages,
}) {
  const itemsPerPage = 18;
  const startItem = (currentPage - 1) * itemsPerPage + 1;
  const endItem = Math.min(currentPage * itemsPerPage, totalItems);

  const renderPageNumbers = () => {
    const pages = [];
    for (let i = 1; i <= totalPages; i++) {
      if (
        i === 1 ||
        i === totalPages ||
        (i >= currentPage - 2 && i <= currentPage + 2)
      ) {
        pages.push(
          <PageNumber
            key={i}
            isActive={i === currentPage}
            onClick={() => goToPage(i)}
          >
            {i}
          </PageNumber>
        );
      } else if (i === currentPage - 3 || i === currentPage + 3) {
        pages.push(<Ellipsis key={i}>...</Ellipsis>);
      }
    }
    return pages;
  };

  if (!totalPages) {
    return null;
  }

  return (
    <PaginationContainer>
      <ProductCount>
        {t('Visar {start}-{end} av {total} produkter', {
          start: startItem,
          end: endItem,
          total: totalItems,
        })}
      </ProductCount>

      {!isLastPage && (
        <>
          <ShowMoreButton onClick={nextPage}>
            {t('Visa fler produkter')}
          </ShowMoreButton>
          <StatusBar currentPage={currentPage} totalPages={totalPages} />
        </>
      )}

      {hasPages && totalPages > 1 && (
        <PaginationWrapper>{renderPageNumbers()}</PaginationWrapper>
      )}
    </PaginationContainer>
  );
}
